<div class="page">
  <kgrid
    [apiName]="apiName"
    [noAutoFitColumns]="true"
    [label]="label"
    [areaName]="areaName"
    [name]="apiName"
    reportName="CustomerReceiptPayment"
    pathPreFix="SALE"
    [filters]="filters"
    [isMulti]="true"
    [isEdit]="false"
    [inputEditorform]="inputEditorform"
    [unSortableFilterable]="unSortableFilterable"
    [hasBracketForNegativeValues]="false">
  </kgrid>
</div>
